import {Button, OverlayTrigger, Popover} from "react-bootstrap";
import React from "react";

export default (
    {
        onConfirm,
        title = 'Запись будет удалена',
        buttonText = 'Удалить',
        placement = 'left',
        children
    }) => {
    const popover = (
        <Popover
            id="popover-delete-confirm"
            title={title}
            style={{textAlign: 'center'}}
        >
            <Button bsStyle="danger" onClick={onConfirm}>{buttonText}</Button>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" rootClose placement={placement} overlay={popover}>
            {children}
        </OverlayTrigger>
    );
}

